/* eslint-disable import/prefer-default-export */
export const storeMainCategory = [
  {value: 'Automotriz - Automotoras', label: 'Automotriz - Automotoras'},
  {value: 'Automotriz - Repuestos y Artículos para Autos', label: 'Automotriz - Repuestos y Artículos para Autos'},
  {value: 'Belleza - Capilar', label: 'Belleza - Capilar'},
  {value: 'Belleza - Maquillaje y Uñas', label: 'Belleza - Maquillaje y Uñas'},
  {value: 'Belleza - Perfumería', label: 'Belleza - Perfumería'},
  {value: 'Belleza - Rostro y Cuerpo', label: 'Belleza - Rostro y Cuerpo'},
  {value: 'Calzado', label: 'Calzado'},
  {value: 'Accesorios de moda', label: 'Accesorios de moda'},
  {value: 'Decohogar - Alfombras y Cortinas', label: 'Decohogar - Alfombras y Cortinas'},
  {value: 'Decohogar - Baño', label: 'Decohogar - Baño'},
  {value: 'Decohogar - Cama', label: 'Decohogar - Cama'},
  {value: 'Decohogar - Cocina', label: 'Decohogar - Cocina'},
  {value: 'Decohogar - Colchoneria', label: 'Decohogar - Colchoneria'},
  {value: 'Decohogar - Decoración', label: 'Decohogar - Decoración'},
  {value: 'Decohogar - Libros', label: 'Decohogar - Libros'},
  {value: 'Decohogar - Maletería', label: 'Decohogar - Maletería'},
  {value: 'Decohogar - Mascotas', label: 'Decohogar - Mascotas'},
  {value: 'Decohogar - Mesa', label: 'Decohogar - Mesa'},
  {value: 'Decohogar - Muebles', label: 'Decohogar - Muebles'},
  {value: 'Decohogar - Plantas y flores', label: 'Decohogar - Plantas y flores'},
  {value: 'Decohogar - Regalos', label: 'Decohogar - Regalos'},
  {value: 'Deporte - Actividades Deportivas y Tiempo Libre', label: 'Deporte - Actividades Deportivas y Tiempo Libre'},
  {value: 'Deporte - Bicicletas y Movilidad Eléctrica', label: 'Deporte - Bicicletas y Movilidad Eléctrica'},
  {value: 'Deporte - Máquinas y Fitness', label: 'Deporte - Máquinas y Fitness'},
  {value: 'Deporte - Outdoor', label: 'Deporte - Outdoor'},
  {value: 'Deporte - Vestuario (Textil)', label: 'Deporte - Vestuario (Textil)'},
  {value: 'Deporte - Zapatillas (Marca)', label: 'Deporte - Zapatillas (Marca)'},
  {value: 'Electro', label: 'Electro'},
  {value: 'Ferretería', label: 'Ferretería'},
  {value: 'Infantil duros - Mundo Bebé', label: 'Infantil duros - Mundo Bebé'},
  {value: 'Infantil duros - Dormitorio', label: 'Infantil duros - Dormitorio'},
  {value: 'Infantil duros - Escolares', label: 'Infantil duros - Escolares'},
  {value: 'Infantil duros - Estimulación y Alimentación', label: 'Infantil duros - Estimulación y Alimentación'},
  {value: 'Infantil duros - Juegos Exterior', label: 'Infantil duros - Juegos Exterior'},
  {value: 'Infantil duros - Juguetería', label: 'Infantil duros - Juguetería'},
  {value: 'Infantil duros - Librería y Papelería', label: 'Infantil duros - Librería y Papelería'},
  {value: 'Infantil duros - Manualidades', label: 'Infantil duros - Manualidades'},
  {value: 'Infantil duros - Rodados', label: 'Infantil duros - Rodados'},
  {value: 'Inmobiliaria (Casas y Departamentos)', label: 'Inmobiliaria (Casas y Departamentos)'},
  {value: 'Internacional', label: 'Internacional'},
  {value: 'Multicategoría', label: 'Multicategoría'},
  {value: 'Ropa Interior', label: 'Ropa Interior'},
  {value: 'Salud y Bienestar - Artículos Médicos', label: 'Salud y Bienestar - Artículos Médicos'},
  {value: 'Salud y Bienestar - Bienestar Sexual', label: 'Salud y Bienestar - Bienestar Sexual'},
  {value: 'Salud y Bienestar - Farmacia', label: 'Salud y Bienestar - Farmacia'},
  {value: 'Salud y Bienestar - Ortopedia', label: 'Salud y Bienestar - Ortopedia'},
  {value: 'Salud y Bienestar - Protección Covid (Mascarillas, alcohol gel, etc.)', label: 'Salud y Bienestar - Protección Covid (Mascarillas, alcohol gel, etc.)'},
  {value: 'Salud y Bienestar - Vitaminas y Suplementos', label: 'Salud y Bienestar - Vitaminas y Suplementos'},
  {value: 'Servicios - Automotriz y Inmobiliaria', label: 'Servicios - Automotriz y Inmobiliaria'},
  {value: 'Servicios - Belleza y Bienestar', label: 'Servicios - Belleza y Bienestar'},
  {value: 'Servicios - Cursos y Talleres', label: 'Servicios - Cursos y Talleres'},
  {value: 'Servicios - Donaciones', label: 'Servicios - Donaciones'},
  {value: 'Servicios - Entretención y Tiempo Libre', label: 'Servicios - Entretención y Tiempo Libre'},
  {value: 'Servicios - Gastronomía', label: 'Servicios - Gastronomía'},
  {value: 'Servicios - Hotelería, Turismo y Estadía', label: 'Servicios - Hotelería, Turismo y Estadía'},
  {value: 'Servicios - Servicios Domésticos', label: 'Servicios - Servicios Domésticos'},
  {value: 'Supermercado - Despensa', label: 'Supermercado - Despensa'},
  {value: 'Supermercado - Licores, bebidas y jugos', label: 'Supermercado - Licores, bebidas y jugos'},
  {value: 'Supermercado - Limpieza y hogar', label: 'Supermercado - Limpieza y hogar'},
  {value: 'Tecno', label: 'Tecno'},
  {value: 'Vestuario - Hombre', label: 'Vestuario - Hombre'},
  {value: 'Vestuario - Infantil (Ropa de niños y Bebé)', label: 'Vestuario - Infantil (Ropa de niños y Bebé)'},
  {value: 'Vestuario - Mujer', label: 'Vestuario - Mujer'},
]

export const storeNewCategories = [
  {value: 'Accesorios de Moda y Vestuario (infantil/hombre/mujer)', label: 'Accesorios de Moda y Vestuario (infantil/hombre/mujer)'},
  {value: 'Calzado (infantil/hombre/mujer)', label: 'Calzado (infantil/hombre/mujer)'},
  {value: 'Infantil duros ', label: 'Infantil duros '},
  {value: 'Mascotas', label: 'Mascotas'},
  {value: 'Supermercado', label: 'Supermercado'},
  {value: 'Electro', label: 'Electro'},
  {value: 'Salud y Bienestar', label: 'Salud y Bienestar'},
  {value: 'Belleza', label: 'Belleza'},
  {value: 'Automotriz', label: 'Automotriz'},
  {value: 'Deporte ', label: 'Deporte '},
  {value: 'Tecno', label: 'Tecno'},
  {value: 'Ferretería', label: 'Ferretería'},
  {value: 'Decohogar', label: 'Decohogar'},
  {value: 'Servicios', label: 'Servicios'},
  {value: 'Inmobiliaria', label: 'Inmobiliaria'},
  {value: 'Internacional', label: 'Internacional'},
]